import apiConfig from '../config/api';

const rolloutAPI = `${apiConfig.loginAV2API}`;

export const whiteListAPI = (rut) =>
  fetch(`${rolloutAPI}v1/listaBlanca/verificar/${rut}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      'Accept-Language': 'es',
    },
  });
